import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconOnlinePayments: React.FC<IconProps> = ({ ...props }) => {
  return (
    <Icon {...props}>
      <path d="M20.016 8.016v-2.016h-16.031v2.016h16.031zM20.016 18v-6h-16.031v6h16.031zM20.016 3.984q0.844 0 1.406 0.586t0.563 1.43v12q0 0.844-0.563 1.43t-1.406 0.586h-16.031q-0.844 0-1.406-0.586t-0.563-1.43v-12q0-0.844 0.563-1.43t1.406-0.586h16.031z" />
    </Icon>
  );
};

export default IconOnlinePayments;
